import React from 'react';

// Reusable inline SVG icons for social media, replacing external library dependency.
const FacebookIcon = ({ size, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width={size}
    height={size}
    style={style}
  >
    <path d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h2V2h-3.5c-4 0-4.5 3.05-4.5 5.27V10H7v4h4v9h5v-9z"/>
  </svg>
);

const TwitterIcon = ({ size, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width={size}
    height={size}
    style={style}
  >
    <path d="M22.46 6c-.84.37-1.74.62-2.67.73.96-.58 1.7-1.5 2.04-2.58-.9.53-1.9.92-2.94 1.13-.85-.9-2.06-1.46-3.39-1.46-2.57 0-4.66 2.09-4.66 4.66 0 .36.04.71.12 1.05-3.88-.2-7.3-2.06-9.6-4.89-.4 1-.64 2.05-.64 3.2 0 1.61.82 3.03 2.06 3.86-.76-.02-1.47-.23-2.1-.58v.06c0 2.27 1.61 4.16 3.74 4.59-.39.1-.8.15-1.22.15-.3 0-.58-.03-.86-.08.59 1.85 2.3 3.2 4.31 3.23-1.61 1.26-3.64 2.01-5.87 2.01-.38 0-.76-.02-1.13-.07 2.08 1.34 4.56 2.13 7.21 2.13 8.64 0 13.36-7.15 13.36-13.36 0-.2-.01-.4-.02-.6.92-.66 1.72-1.49 2.36-2.4z"/>
  </svg>
);

const InstagramIcon = ({ size, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width={size}
    height={size}
    style={style}
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2.4 13.31a.8.8 0 0 1-.8-.8V10.1a.8.8 0 0 1 .8-.8h4.8a.8.8 0 0 1 .8.8v4.41a.8.8 0 0 1-.8.8h-4.8zM12 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
  </svg>
);

const LinkedinIcon = ({ size, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width={size}
    height={size}
    style={style}
  >
    <path d="M22.23 0H1.77C.8 0 0 .77 0 1.73v20.54C0 23.23.8 24 1.77 24h20.46c.97 0 1.77-.77 1.77-1.73V1.73C24 .77 23.2 0 22.23 0zM7.06 20.46H3.59V9.52h3.47v10.94zm-1.74-12.2c-1.15 0-2.08-.94-2.08-2.08s.93-2.08 2.08-2.08 2.08.93 2.08 2.08-.93 2.08-2.08 2.08zm14.39 12.2h-3.46V15.7c0-.85-.01-1.95-1.19-1.95-1.19 0-1.37.93-1.37 1.89v4.82H10.1V9.52h3.32v1.54h.05c.46-.88 1.58-1.8 3.25-1.8 3.47 0 4.11 2.28 4.11 5.24v6.16z"/>
  </svg>
);


export default function Footer() {
  return (
    <footer style={{
      padding: '0',
      backgroundColor: '#0f172a',
      color: 'white',
      fontFamily: 'Poppins, sans-serif',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Waving Layer SVG at the top of the footer */}
      <svg
        style={{
          position: 'absolute',
          top: '-1px',
          left: '0',
          width: '100%',
          zIndex: 1,
          transform: 'rotate(180deg)',
        }}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
      >
        <path
          fill="#0f172a"
          fillOpacity="1"
          d="M0,288L60,266.7C120,245,240,203,360,208C480,213,600,267,720,282.7C840,299,960,277,1080,272C1200,267,1320,277,1380,282.7L1440,288L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
        ></path>
      </svg>
      <div style={{
        padding: '3rem 1rem',
        position: 'relative',
        zIndex: 2,
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between', 
        alignItems: 'flex-start',
        gap: '2rem',
        textAlign: 'left',
      }}>
        {/* Company Logo, Name, and Slogan in a single container */}
        <div style={{
          flex: 1,
          minWidth: '250px',
          padding: '1rem',
          textAlign: 'left',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}>
          {/* Logo and company name as a heading */}
          <h2 style={{
            display: 'flex',
            alignItems: 'center',
            margin: '0 0 0.5rem 0', // Reduced margin for closer placement of the quote
          }}>
            <img
              src="logo512.png"
              alt="Company Logo"
              style={{
                height: '48px',
                width: '48px',
                borderRadius: '50%',
                marginRight: '8px',
              }}
            />
            <span style={{
              fontSize: '24px',
              fontWeight: 400,
              color: '#ff8c00', 
              fontFamily: 'serif',
            }}>
              GIRRAJ <span style={{
                fontWeight: 700,
                color: '#ffffff',
              }}>TECHNOLOGY</span>
            </span>
          </h2>
          {/* The slogan is now a quote directly under the heading */}
          <blockquote style={{
            margin: '0',
            fontSize: '0.95rem',
            color: '#94a3b8',
            lineHeight: 1.6,
            marginBottom: '1rem',
            borderLeft: '3px solid #d4b68f',
            paddingLeft: '1rem',
          }}>
            Building innovative solutions for the future of technology.
          </blockquote>
          <div style={{
            display: 'flex',
            justifyContent: 'flex-start', 
            gap: '1.2rem',
            marginTop: '0.5rem', // Adjusted margin to be closer to the quote
          }}>
            <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" style={{
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              backgroundColor: 'rgba(212, 182, 143, 0.2)',
              color: 'white',
              fontSize: '1.3rem',
              textDecoration: 'none',
              transition: 'background-color 0.3s ease, transform 0.2s ease',
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#d4b68f'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(212, 182, 143, 0.2)'}>
              <FacebookIcon />
            </a>
            <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" aria-label="Twitter" style={{
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              backgroundColor: 'rgba(212, 182, 143, 0.2)',
              color: 'white',
              fontSize: '1.3rem',
              textDecoration: 'none',
              transition: 'background-color 0.3s ease, transform 0.2s ease',
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#d4b68f'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(212, 182, 143, 0.2)'}>
              <TwitterIcon />
            </a>
            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" style={{
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              backgroundColor: 'rgba(212, 182, 143, 0.2)',
              color: 'white',
              fontSize: '1.3rem',
              textDecoration: 'none',
              transition: 'background-color 0.3s ease, transform 0.2s ease',
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#d4b68f'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(212, 182, 143, 0.2)'}>
              <InstagramIcon />
            </a>
            <a href="https://linkedin.com/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" style={{
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              backgroundColor: 'rgba(212, 182, 143, 0.2)',
              color: 'white',
              fontSize: '1.3rem',
              textDecoration: 'none',
              transition: 'background-color 0.3s ease, transform 0.2s ease',
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#d4b68f'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(212, 182, 143, 0.2)'}>
              <LinkedinIcon />
            </a>
          </div>
        </div>
        
        <div style={{
          flex: 1,
          minWidth: '250px',
          padding: '1rem',
        }}>
          <h3 style={{
            fontSize: '1.8rem',
            marginBottom: '1rem',
            color: '#d4b68f',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
          }}>Quick Links</h3>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
          }}>
            <li><a href="/" style={{
              color: 'white',
              fontSize: '0.95rem',
              textDecoration: 'none',
              display: 'block',
              marginBottom: '0.7rem',
              transition: 'color 0.3s ease',
              position: 'relative',
              paddingLeft: '15px',
            }}
            onMouseEnter={e => e.currentTarget.style.color = '#d4b68f'}
            onMouseLeave={e => e.currentTarget.style.color = 'white'}>Home</a></li>
            <li><a href="/aboutus" style={{
              color: 'white',
              fontSize: '0.95rem',
              textDecoration: 'none',
              display: 'block',
              marginBottom: '0.7rem',
              transition: 'color 0.3s ease',
              position: 'relative',
              paddingLeft: '15px',
            }}
            onMouseEnter={e => e.currentTarget.style.color = '#d4b68f'}
            onMouseLeave={e => e.currentTarget.style.color = 'white'}>About Us</a></li>
            <li><a href="/service" style={{
              color: 'white',
              fontSize: '0.95rem',
              textDecoration: 'none',
              display: 'block',
              marginBottom: '0.7rem',
              transition: 'color 0.3s ease',
              position: 'relative',
              paddingLeft: '15px',
            }}
            onMouseEnter={e => e.currentTarget.style.color = '#d4b68f'}
            onMouseLeave={e => e.currentTarget.style.color = 'white'}>Our Services</a></li>
            <li><a href="/team" style={{
              color: 'white',
              fontSize: '0.95rem',
              textDecoration: 'none',
              display: 'block',
              marginBottom: '0.7rem',
              transition: 'color 0.3s ease',
              position: 'relative',
              paddingLeft: '15px',
            }}
            onMouseEnter={e => e.currentTarget.style.color = '#d4b68f'}
            onMouseLeave={e => e.currentTarget.style.color = 'white'}>Our Team</a></li>
            <li><a href="/contact" style={{
              color: 'white',
              fontSize: '0.95rem',
              textDecoration: 'none',
              display: 'block',
              marginBottom: '0.7rem',
              transition: 'color 0.3s ease',
              position: 'relative',
              paddingLeft: '15px',
            }}
            onMouseEnter={e => e.currentTarget.style.color = '#d4b68f'}
            onMouseLeave={e => e.currentTarget.style.color = 'white'}>Contact Us</a></li>
          </ul>
        </div>
      </div>
      <p style={{
        fontSize: '0.9rem',
        color: '#94a3b8',
        marginTop: '2rem',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        paddingTop: '1.5rem',
        textAlign: 'center',
        position: 'relative',
        zIndex: 2,
      }}>© 2024 GirrajTechnology. All rights reserved.</p>
      
      {/* Styles for responsiveness */}
      <style jsx>{`
        @media (max-width: 992px) {
          footer > div:first-child {
            flex-direction: column;
            align-items: center;
            gap: 2rem;
          }
          footer > div > div {
            width: 90%;
            max-width: 450px;
            text-align: center;
          }
          footer > div > div:first-child {
            text-align: center;
          }
          ul {
            text-align: center !important;
          }
          li a {
            padding-left: 0 !important;
          }
        }
        @media (max-width: 576px) {
          footer {
            padding: 2rem 0.5rem;
          }
          h3 {
            font-size: 1.6rem;
          }
          p, a {
            font-size: 0.85rem;
          }
          a > svg {
            width: 35px;
            height: 35px;
            font-size: 1.1rem;
          }
        }
      `}</style>
    </footer>
  );
}